var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgBlockItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.25V22.5M16.5 18V22.5M19.5 15.75V22.5M22.5 13.5V22.5M12 26.25H24C25.2426 26.25 26.25 25.2426 26.25 24V12C26.25 10.7574 25.2426 9.75 24 9.75H12C10.7574 9.75 9.75 10.7574 9.75 12V24C9.75 25.2426 10.7574 26.25 12 26.25Z",
    stroke: "#216AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBlockItem);
export default __webpack_public_path__ + "static/media/svg_block_item.ae8ade83decc61630e7808a72c08c27e.svg";
export { ForwardRef as ReactComponent };